import { render } from "./NewSource.vue?vue&type=template&id=68d972b6"
import script from "./NewSource.vue?vue&type=script&lang=ts"
export * from "./NewSource.vue?vue&type=script&lang=ts"
script.render = render

export default script